module.exports = __webpack_public_path__ + "8c30d42fb9b7056ac274f4fa272c16ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Playlist/assets/warning.png
// module id = 2288
// module chunks = 1